import { del, get, post } from './httpClient';

/**
 * GET /getlistmembers?list_id= — solo el dueño. Ajeno → 404.
 * `data[]` trae `email` y `user_id` (este puede ser null si todavía no hay cuenta).
 *
 * @param {string} listId
 * @param {{ signal?: AbortSignal }} [options]
 */
export async function getListMembers(listId, { signal } = {}) {
  const list_id = String(listId || '').trim();
  if (!list_id) {
    return { data: [], _httpOk: false, _httpStatus: null };
  }
  return get('/getlistmembers', { params: { list_id }, signal });
}

/**
 * POST /upsertlistmember `{ list_id, email }`. El API resuelve el Cognito sub
 * si esa cuenta ya existe. 201 alta / 200 update. 400 si te invitás a vos.
 *
 * @param {{ list_id: string, email: string }} body
 * @param {{ signal?: AbortSignal }} [options]
 */
export async function upsertListMember(body, { signal } = {}) {
  return post('/upsertlistmember', {
    body: {
      list_id: body?.list_id,
      email: String(body?.email || '').trim().toLowerCase(),
    },
    signal,
  });
}

/**
 * DELETE /deletelistmember?list_id=&email=
 *
 * @param {{ list_id: string, email: string }} body
 * @param {{ signal?: AbortSignal }} [options]
 */
export async function deleteListMember(body, { signal } = {}) {
  const email = String(body?.email || '').trim().toLowerCase();
  return del('/deletelistmember', {
    params: {
      list_id: body?.list_id,
      email,
    },
    signal,
  });
}
